/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { propsUtils } from '@ba-ui-toolkit/utils';
import DatePicker, { datePropType, localPropType } from './DatePicker';

const { BaPropTypes } = propsUtils;

export default class SingleDatepicker extends Component {
	static propTypes = {
		/** The value of the date value provided. It could be a date, a date number,
		 * a date string, an array of dates.
		 */
		date: datePropType,
		/** The `change` event handler. */
		onChange: PropTypes.func,
		/** Placeholder text when no date is selected */
		placeholder: PropTypes.string,
		/** Display format of date following flatpickr documentation */
		displayFormat: PropTypes.string,
		/** The language locale used to format the days of the week, months, and numbers. */
		locale: localPropType,
		/** The CSS class names. */
		className: PropTypes.string,
		/** Custom styling. */
		style: PropTypes.object,
		/** Specify whether the control is disabled */
		disabled: PropTypes.bool,
		/** Deeprecated */
		renderMonth: BaPropTypes.deprecatedByCarbon(SingleDatepicker),
		/** Deeprecated */
		focused: BaPropTypes.deprecatedByCarbon(SingleDatepicker),
		/** Deeprecated */
		onFocusChange: BaPropTypes.deprecatedByCarbon(SingleDatepicker),
	};

	static defaultProps = {
		placeholder: 'YYYY-MM-DD',
	};

	render() {
		const { displayFormat, ...others } = this.props;

		const cProps = {
			...others,
			datePickerType: 'single',
			dateFormat: displayFormat,
		};

		return <DatePicker {...cProps} />;
	}
}
